import React from 'react'

import { Box } from '@mui/material'
import NumSearchesBlock from 'Pages/ReportsAlerts/Reports/@components/NumSearchesBlock'

export default function numSearchesDoneColumn() {

    return {
        name: 'searchesDone',
        label: 'Number of searches performed per refresh',
        options: {
            customBodyRowRenderLite: (value) => (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: value > 1000 ? 'colors.red' : 'colors.green'}}>
                    <NumSearchesBlock numSearches={value}/>
                </Box>
            )
        }
    }
}
